import { Injectable } from '@angular/core';
import { Product } from '../shared/product';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserDetailsService } from './user-details.service';
import { HeaderService } from './header.service';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  apiURL = environment.oneLogApi;

  constructor(
    private http: HttpClient,
    private userDetails: UserDetailsService,
    private headerService: HeaderService
  ) {}

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  // HttpClient API get() method => Fetch Product list
  getProducts(postData: any = []): Observable<Product> {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    const body = JSON.stringify(postData);
    return this.http
      .post<Product>(this.apiURL + '/get_products', body, requestOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  updateProductsStatus(postData: any): Observable<any> {
    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(postData);
    return this.http
      .post(this.apiURL + '/update_product_status', body, { headers: headers })
      .pipe(retry(1), catchError(this.handleError));
  }

  updateProductsDate(postData: any): Observable<any> {
    const headers = this.headerService.setHeaders();
    const body = JSON.stringify(postData);
    return this.http
      .post(this.apiURL + '/update_product_date', body, headers)
      .pipe(retry(1), catchError(this.handleError));
  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
